"use client";

import { Children, useRef } from "react";
import { useInView, useReducedMotion } from "framer-motion";

interface Props {
	children: React.ReactNode;
	initialDelay?: number;
	step?: number;
	duration?: number;
}

const Stagger = ({ children, initialDelay = 0, step = 0.08, duration = 0.6 }: Props) => {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: "0px 0px -10% 0px" });
	const shouldReduceMotion = useReducedMotion();
	const inView = shouldReduceMotion ? true : isInView;

	const items = Children.toArray(children);
	const ease = "cubic-bezier(0.17, 0.55, 0.55, 1)";

	return (
		<div ref={ref}>
			{items.map((child, i) => {
				const delay = shouldReduceMotion ? 0 : initialDelay + i * step;
				const style = {
					opacity: inView ? 1 : 0,
					transform: inView ? "translateY(0)" : "translateY(24px)",
					transition: shouldReduceMotion
						? "none"
						: `opacity ${duration}s ${ease} ${delay}s, transform ${duration}s ${ease} ${delay}s`,
				};
				return (
					<div key={i} style={style}>
						{child}
					</div>
				);
			})}
		</div>
	);
};

export default Stagger;
